import merge from 'deepmerge'
import { isPlainObject } from 'util/objects/isPlainObject'

export const mergePlain = (target, source, options) => {
  return merge(target, source, {
    ...options,
    isMergeableObject: isPlainObject,
  })
}
